<template>
  <div
    class="rounded-t bg-white mb-0 px-6 py-6 flex justify-between uppercase font-bold items-center"
  >
    <button @click="handleGoBack" class="flex">
      <IconChevronLeft />{{
        `New instance for ${formattedComponentName(title)}`
      }}
    </button>
    <div class="text-center flex justify-end items-center">
      <button
        @click="handleCreate"
        class="bg-emerald-500 active:bg-emerald-600 inline-flex items-center text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
      >
        Save
        <IconSync class="ml-1 animate-spin" v-if="getCreateLoading" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IconSync from "@/assets/icons/IconSync";
import IconChevronLeft from "@/assets/icons/IconChevronLeft";

export default {
  name: "SDNComponentCreateHeader",
  components: {
    IconSync,
    IconChevronLeft
  },
  data() {
    return {
      showModal: false
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    handleCreate: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getCreateLoading"])
  },
  emits: ["update:instance"],
  methods: {
    formattedComponentName(name) {
      const splitName = name.split("_");
      splitName[0] = splitName[0].toUpperCase();
      return splitName.join(" ");
    },
    handleGoBack() {
      this.$router.back();
    }
  }
};
</script>
